import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_REVISION: createAsyncMutation('GET_REVISION'),
    GET_VERSIONS: createAsyncMutation('GET_VERSIONS'),
}

const revision = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getRevision(store, payload) {
            let url = api.revision
            if (payload) {
                url += '?productCategoryId=' + payload.productCategoryId
                url += '&version=' + payload.version
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_REVISION })
        },
        getVersions(store, payload) {
            let url = api.revision + 'GetVersions'
            if (payload) {
                url += '?productCategoryId=' + payload.productCategoryId
                url += '&oemAddOn=' + payload.oemAddOn
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_VERSIONS })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default revision
